import { createSlice } from "@reduxjs/toolkit";
import { getAdmin, getChatBot, getFaqById, getPromptById, getSource } from "../Actions/event";

const initialState = {
    loading: false,
    botDetails: {},
    adminDetails: {},
    promptDetails: {},
    sourceDetails:{}
}

const BotSlice = createSlice({
    name: "event",
    initialState,
    reducers: {
        setVisibleRange(state, action) {
            state.visibleRange = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getChatBot.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.botDetails = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getAdmin.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.adminDetails = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getFaqById.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.faqDetails = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getPromptById.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.promptDetails = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getSource.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.sourceDetails = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
    },
});

export const { setVisibleRange } = BotSlice.actions;
export default BotSlice.reducer;